import React, { useEffect, useState } from 'react';
import Select from '../select';
import { SelectProps } from '../select/select';
import { createModel } from '../../utils/modelStore';

import { FetchProps } from '../../utils/type';

interface SelectAsyncProps extends SelectProps {
  initFetch?: FetchProps;
  fetchOptsMember?: any;
  fetchCache?: any;
}

function SelectAsync(props: SelectAsyncProps) {
  const { initFetch, options = [], _crengine, fetchOptsMember, fetchCache } = props;
  const { dataBind, name } = _crengine || {};
  const [dataSource, setDataSource] = useState(options);
  const defaultCacheName = (dataBind || name || '');

  // 从接口获取数据
  useEffect(() => {
    if (!(initFetch)) {
      return () => {};
    }

    const cacheExpire: any = ((fetchCache && fetchCache.expire) ? fetchCache.expire : '');
    const cacheParams: any = ((fetchCache && fetchCache.params) ? fetchCache.params : null);
    // 缓存名字
    let cacheName = defaultCacheName;

    if (fetchCache && fetchCache.name) {
      cacheName = fetchCache.name;
    }

    const defaultOption = {
      method: 'GET',
      data: {},
      ...initFetch,
    };

    createModel(`select_async_${cacheName}`, defaultOption, cacheExpire, cacheParams)
      .execute((result) => {
        if (result && result.code === 0 && result.result) {
          const { options: tempOptions, ...others } = result.result;
          let tempDataSource = tempOptions;
          const dataName = (fetchOptsMember || cacheName);

          // dataSource值
          if (
            dataName
            && result.result[dataName]
          ) {
            tempDataSource = others[dataName];
            delete others[dataName];
          }

          if (Array.isArray(tempDataSource) && tempDataSource.length) {
            setDataSource(tempDataSource);
          } else {
            console.error('select-async datasource需要返回数组');
          }
        }
      });
    return () => {};
  }, [initFetch, defaultCacheName, fetchOptsMember, fetchCache]);

  return (
    <Select {...props} paramType="object" options={dataSource} />
  );
}

export default SelectAsync;
